<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :okText="okText"
    @ok="handleOk"
    :wrapClassName="wrapClassName"
    @cancel="handleCancel"
    :zIndex="zIndex"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      <p v-if="isShowHtml" v-html="contentStr"></p>
      <p v-else>{{ contentStr }}</p>
    </slot>
  </a-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    contentStr: {
      type: String,
      default: ''
    },
    wrapClassName: {
      type: String,
      default: 'common-secondary-confirmation-modal'
    },
    okText: {
      type: String,
      default: '确定'
    },
    width: {
      type: String,
      default: '520px'
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    isShowHtml: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      confirmLoading: false
    };
  },
  created() {
    console.log(this);
  },
  methods: {
    handleOk() {
      this.$emit('handleOk', this);
    },
    handleCancel() {
      this.visible = false;
      this.$emit('handleCancel');
    }
  }
};
</script>

<style>
</style>